import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { withShowOnceBanner } from "../../withShowOnceBanner";
import {
    FormActionHandlerExecutionInjectableProps,
    withFormActionHandlerExecution,
} from "../../Internals/FormActionHandlers/WithFormActionHandlerExecution";
import { FormActionHandler } from "../../Internals/FormActionHandlers/FormActionHandler";

import { Banner, BannerProps } from "./Banner";

interface BannerContainerProps extends Omit<BannerProps, "onClick">, FormActionHandlerExecutionInjectableProps {
    onClick?: FormActionHandler;
}

const mapStateToProps = (state: FullFormState, ownProps: BannerContainerProps) => ({
    userId: state.settings.userId,
    isReadOnly: state.settings.isReadOnly,
    onClick: ownProps.onClick
        ? async () => {
              if (ownProps.onClick) {
                  await ownProps.executeFormActionHandler(ownProps.onClick);
              }
          }
        : undefined,
});

export const BannerContainer = withFormActionHandlerExecution(connect(mapStateToProps)(withShowOnceBanner(Banner)));
